import { compose } from 'redux'
import View from './XShareButton'
import { connect } from 'react-redux'
import { shareOnSocial } from '../../../../store/modules/social'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const mapDispatchToProps = dispatch => ({
  shareOnSocial: compose(dispatch, shareOnSocial),
})

const XShareButton = connect(mapStateToProps, mapDispatchToProps)(View)

export default XShareButton
